import z from "zod";
import {
  dateOperatorSchema,
  numberOperatorSchema,
  stringOperatorSchema,
} from "../operations/operation-filter";

export const filterPaymentIntendSchema = z.object({
  reference: stringOperatorSchema.optional(),
  rateId: stringOperatorSchema.optional(),
  userId: stringOperatorSchema.optional(),
  status: numberOperatorSchema.optional(),
  Amount: numberOperatorSchema.optional(),
  toAmbassador: numberOperatorSchema.optional(),
  openDate: dateOperatorSchema.optional(),
  closeDate: dateOperatorSchema.optional(),
});

export const filterTransactionSchema = z.object({
  Amount: numberOperatorSchema.optional(),
  toAmbassador: numberOperatorSchema.optional(),
  closeDate: dateOperatorSchema.optional(),
});

export const filterPaymentIntendByAmbassadorSchema = filterTransactionSchema.extend({
  ambassador: z.string(),
});

export type FilterPaymentIntendType = z.infer<typeof filterPaymentIntendSchema>;
export type FilterPaymentIntendTypeByAmbassador = z.infer<
  typeof filterPaymentIntendByAmbassadorSchema
>;
export type FilterTransaction = z.infer<typeof filterTransactionSchema>;
